import { makeStyles } from '@material-ui/core/styles';

export const useConditionalContentContainerStyles = makeStyles(
  ({ spacing }) => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: spacing(1),
      width: '100%',
    },
  }),
  { name: 'ConditionalContentContainer' },
);
